import Vue from 'vue'
import Vuex from 'vuex'
import jwtDecode from 'jwt-decode'

import defaultMutations from './mutations'
import defaultActions from './actions'
import allActions from './actions/'
import allMutations from './mutations/'
import menu from './accessLevel'
import { getToken, isTokenExpired } from './../helpers/auth-storage'
Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

let user

try {
  const token = getToken()
  if (!token || isTokenExpired(token)) {
    throw new Error('token expired')
  }
  user = jwtDecode(token).user
} catch (e) {
  user = ''
}

const state = {
  user,
  menu: menu,
  news: [],
  events: [],
  services: [],
  servicePromos: [],
  agencies: [],
  promos: [],
  pages: [],
  page: {},
  emitents: [],
  license: [],
  documentTypes: [],
  newDocumentTypes: [],
  deponentsData: [],
  documents: [],
  fDocuments: [],
  disclosureInformation: [],
  emitentsData: [],
  eventCities: [],
  chiefs: [],
  accounts: [],
  publications: [],
  publication: null,
  requisites: [],
  roles: [],
  speakers: [],
  clubs: [],
  clients: [],
  webinars: [],
  webinarsReviews: [],
  serviceRequests: [],
  requiredInformation: [],
  brokerInformation: [],
  consultationRequests: [],
  dataForClients: [],
  software: {
    packages: [],
    apps: []
  },
  service: null,
  agency: null,
  event: null,
  club: null,
  eventCity: null,
  documentType: null,
  settings: null,
  commonServices: [],
  commonServicesType: [],
  files: [],
  partners: [],
  partner: {},
  brandReviews: [],
  brandAchievements: [],
  recommendationLetters: [],
  brokerageHouses: [],
  individualInvestment: null,
  bondedLoan: null,
  investorPage: null,
  investorPages: [],
  redirects: [],
  metaTags: [],
  financialClubInfo: null,
  claimInfo: {},
  claims: [],
  submissionAppOperations: []
}

const actions = Object.assign(defaultActions, allActions)
const mutations = Object.assign(defaultMutations, allMutations)

export default new Vuex.Store({
  state,
  actions,
  mutations,
  strict: debug
})



// WEBPACK FOOTER //
// ./src/store/index.js